import actions from "./actions";

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  setScreenshot: actions.setScreenshot
};
